import React, { memo, useMemo } from 'react';
import { Modal } from '@bringg/react-components';
import { useTranslation } from 'react-i18next';
// TODO: make it accessible in a normal way
import type { ModalProps } from '@bringg/react-components/dist/components/modal/modal';

import { TRANSLATION_DOMAINS } from '../../../consts';

import './dismiss-confirm.scss';

const { EXCEPTIONS_LIST: domain } = TRANSLATION_DOMAINS;

interface Props extends ModalProps {
	countToDismiss: number;
}

function DismissConfirm({ countToDismiss, ...rest }: Props) {
	const { t } = useTranslation();
	const title = useMemo(
		() => (
			<>
				<span className="color-sticker warning" />
				<span>{t(`${domain}.WARNING`)}</span>
			</>
		),
		[t]
	);
	const countKey = `${domain}.${countToDismiss === 1 ? 'ALERT' : 'ALERTS'}`;
	const content = useMemo(
		() => `${t(`${domain}.SURE_TO_DISMISS`)} ${countToDismiss} ${t(countKey)}?`,
		[t, countKey, countToDismiss]
	);
	const okButtonProps = useMemo<ModalProps['okButtonProps']>(
		() => ({
			className: 'alert-dismiss-confirm'
		}),
		[]
	);
	const cancelButtonProps = useMemo<ModalProps['cancelButtonProps']>(
		() => ({
			className: 'alert-dismiss-cancel',
			type: 'text'
		}),
		[]
	);

	return (
		<Modal
			{...rest}
			closable={false}
			className="bringg-modal dismiss-alert-modal"
			okText={t(`${domain}.CONFIRM`)}
			cancelText={t(`${domain}.CANCEL`)}
			title={title}
			okButtonProps={okButtonProps}
			cancelButtonProps={cancelButtonProps}
			centered
		>
			{content}
		</Modal>
	);
}

export default memo(DismissConfirm) as typeof DismissConfirm;
